module.exports = __webpack_public_path__ + "img/about.ba5fb072.jpg";